import { CheckCircle2, XCircle, Clock, CircleDot, Star, Hourglass } from "lucide-react";

const statusMap = {
    holdt: { label: "Holdt", icon: CheckCircle2, className: "status-holdt" },
    brudt: { label: "Brudt", icon: XCircle, className: "status-brudt" },
    delvist: { label: "Delvist holdt", icon: CircleDot, className: "status-delvist" },
    afventer: { label: "Afventer", icon: Clock, className: "status-afventer" },
};

const DIFFICULTY_LABELS = {
    1: "Meget let",
    2: "Let",
    3: "Middel",
    4: "Svær",
    5: "Meget svær reform",
};

function DifficultyStars({ difficulty = 3 }) {
    const d = Math.max(1, Math.min(5, difficulty));
    return (
        <span
            className="inline-flex items-center gap-0.5"
            title={`Sværhedsgrad: ${DIFFICULTY_LABELS[d]} (${d}/5)`}
            data-testid={`difficulty-${d}`}
        >
            {[1, 2, 3, 4, 5].map((i) => (
                <Star
                    key={i}
                    className="w-3 h-3"
                    fill={i <= d ? "#F4C96B" : "none"}
                    stroke={i <= d ? "#C89A2A" : "#C2CBDC"}
                    strokeWidth={1.5}
                />
            ))}
        </span>
    );
}

export default function PromiseCard({ promise, partyColor, partyName }) {
    const s = statusMap[promise.status] || statusMap.afventer;
    const Icon = s.icon;
    return (
        <div
            className="bg-white border border-[#E5E8F0] rounded-xl p-5 hover-lift"
            data-testid={`promise-card-${promise.id}`}
        >
            <div className="flex items-start justify-between gap-4 mb-3">
                <div className="flex items-center gap-2">
                    {partyName && partyColor && (
                        <span
                            className="inline-block w-2.5 h-2.5 rounded-full"
                            style={{ backgroundColor: partyColor }}
                        />
                    )}
                    {partyName && (
                        <span className="text-xs uppercase tracking-wider text-[#4F5A7A] font-semibold">
                            {partyName}
                        </span>
                    )}
                    <span className="text-xs text-[#8A94AE]">· {promise.category}</span>
                </div>
                <span className={`inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-semibold ${s.className}`}>
                    <Icon className="w-3 h-3" />
                    {s.label}
                </span>
            </div>
            <h3 className="font-serif-dm text-lg text-royal leading-tight mb-2">
                {promise.title}
            </h3>
            <p className="text-sm text-[#4F5A7A] leading-relaxed mb-3">
                {promise.description}
            </p>
            {promise.status === "afventer" && promise.pending_days != null && (
                <div
                    className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-[#FFF4E3] border border-[#F4C96B]/60 text-[#8A5B00] text-xs font-semibold mb-3"
                    data-testid={`pending-days-${promise.id}`}
                    title="Antal dage siden løftet blev afgivet uden at være indfriet"
                >
                    <Hourglass className="w-3.5 h-3.5" />
                    Afventer i {promise.pending_days.toLocaleString("da-DK")} dage
                </div>
            )}
            <div className="flex flex-wrap items-center gap-3 text-xs text-[#8A94AE] pt-3 border-t border-[#EEF0F7]">
                <DifficultyStars difficulty={promise.difficulty} />
                <span>·</span>
                <span>Afgivet: {new Date(promise.date_made).toLocaleDateString("da-DK")}</span>
                {promise.source && <span>· Kilde: {promise.source}</span>}
            </div>
        </div>
    );
}
